/*
 * COOKNRUN - JS maison (chargé par snippets/cnr-head.liquid)
 * 1. Menu mobile : "Produits" (1er item à sous-menu) déplié automatiquement à l'ouverture du tiroir.
 * 2. Footer : logos partenaires (1% for the Planet, Impact France) sous le logo COOKNRUN.
 */
(function () {
  function drawer() {
    return document.querySelector('drawer-element.drawer--nav, #nav-drawer-section, #nav-drawer');
  }
  function isOpen(el) {
    if (!el) return false;
    if (el.classList.contains('is-open') || el.hasAttribute('open')) return true;
    var r = el.getBoundingClientRect();
    return r.width > 4 && r.height > 4 && getComputedStyle(el).visibility !== 'hidden';
  }
  function ensureExpanded(el, tries) {
    var item = el.querySelector('.mobile-menu__item--level-1.mobile-menu__item--has-items');
    var trigger = item && item.querySelector(':scope > [data-collapsible-trigger]');
    var container = item && item.querySelector(':scope > [data-collapsible-container]');
    if (!trigger || !container) {
      if (tries > 0) setTimeout(function () { ensureExpanded(el, tries - 1); }, 200);
      return;
    }
    if (container.classList.contains('is-expanded')) return;
    trigger.click();
    if (tries > 0) {
      setTimeout(function () {
        if (!container.classList.contains('is-expanded')) ensureExpanded(el, tries - 1);
      }, 250);
    }
  }
  function init() {
    var el = drawer();
    if (!el) return;
    var busy = false;
    function onOpen() {
      if (busy || !isOpen(el)) return;
      busy = true;
      setTimeout(function () { ensureExpanded(el, 6); }, 80);
    }
    new MutationObserver(function () {
      if (isOpen(el)) onOpen(); else busy = false;
    }).observe(el, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-menu-trigger], .js-drawer-open')) setTimeout(onOpen, 150);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  function partners() {
    var block = document.querySelector('.footer-block--logo');
    if (!block || block.querySelector('.cnr-partners')) return;
    var wrap = document.createElement('div');
    wrap.className = 'cnr-partners';
    wrap.style.cssText = 'display:flex;flex-direction:column;align-items:flex-start;gap:10px;margin-top:20px;';
    wrap.innerHTML =
      '<a href="https://www.onepercentfortheplanet.fr/" target="_blank" rel="noopener">' +
      '<img src="https://cdn.shopify.com/s/files/1/0549/6815/6258/files/1_FPT_white_inline.svg?v=1685702078" alt="1% For the Planet" width="90" style="display:block;width:90px;height:auto;" loading="lazy"></a>' +
      '<a href="https://www.impactfrance.eco/" target="_blank" rel="noopener">' +
      '<img src="https://cdn.shopify.com/s/files/1/0549/6815/6258/files/Cartouche_blanche.png?v=1685711863" alt="Mouvement IMPACT FRANCE" width="90" style="display:block;width:90px;height:auto;" loading="lazy"></a>';
    var logo = block.querySelector('.footer-block__logo-image');
    if (logo) logo.insertAdjacentElement('afterend', wrap); else block.appendChild(wrap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', partners);
  else partners();
})();
